// extracted by mini-css-extract-plugin
module.exports = {"App":"ArtistItem_App__Oz4Ue","artistItemContainer":"ArtistItem_artistItemContainer__J_XAM","imgContainer":"ArtistItem_imgContainer__1iPYA"};